import { PageHero } from "../components/Shared";
import ContactSection from "../sections/ContactSection";
import { IMAGES } from "../data/site";

const ContactPage = () => (
  <main data-testid="contact-page">
    <PageHero
      eyebrow="Contact"
      title="Let's Bring Your Next Print Project to Life."
      description="Reach us directly, or share your requirements through the form below."
      image={IMAGES.paper}
    />
    <ContactSection />
  </main>
);

export default ContactPage;
